module.exports = __webpack_public_path__ + "img/control.e945e0aa.svg";